// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import type { OperationOptions } from "@azure-rest/core-client";

/** Optional parameters. */
export interface ManagementPoliciesDeleteOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface ManagementPoliciesCreateOrUpdateOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface ManagementPoliciesGetOptionalParams extends OperationOptions {}
